import React from "react";
import { Layout, Menu, Avatar, Typography, Row, Col, Card, App } from "antd";
import {
  HomeOutlined,
  FilePdfOutlined,
  QrcodeOutlined,
  UserOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FilePptOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";

const { Header, Sider, Content } = Layout;
const { Title, Paragraph } = Typography;

const DashboardHome = () => {
  const { notification, message } = App.useApp();
  const navigate = useNavigate();
  return (
    <>
      {/* QR dashboard */}
      <Title level={4} className="dashboard-title">
        Static QR
      </Title>
      <Paragraph className="dashboard-subtitle">
        Reprint required when updating content
      </Paragraph>

      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Card
            size="small"
            hoverable
            className="dashboard-card"
            onClick={() => {
              navigate("/dashboard/qr-link");
            }}
          >
            <div className="dashboard-card-content">
              <img
                src={require("../../assets/dashboard/link-to-qr.png")}
                className="dashboard-card-icon"
              />
              <div>
                <br />
                <Title level={5} style={{ margin: 0 }}>
                  Website or URL
                </Title>
                <Paragraph style={{ margin: 0 }}>
                  Generate QR Code for Website or URL
                </Paragraph>
              </div>
            </div>
          </Card>
        </Col>
        <Col span={12}>
          <Card
            size="small"
            hoverable
            className="dashboard-card"
            onClick={() => {
              navigate("/dashboard/qr-text");
            }}
          >
            <div className="dashboard-card-content">
              <img
                src={require("../../assets/dashboard/text-to-qr.png")}
                className="dashboard-card-icon"
              />
              <div>
                <br />
                <Title level={5} style={{ margin: 0 }}>
                  Text
                </Title>
                <Paragraph style={{ margin: 0 }}>
                  Generate QR Code for Plain Text
                </Paragraph>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* PDF dashboard */}
      <Title level={4} className="dashboard-title">
        Generate PDF
      </Title>
      <Paragraph className="dashboard-subtitle">
        Simplify Your PDF Tasks Effortlessly
      </Paragraph>

      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Card
            size="small"
            hoverable
            className="dashboard-card"
            onClick={() => {
              navigate("/dashboard/word2pdf");
            }}
          >
            <div className="dashboard-card-content">
              <img
                src={require("../../assets/dashboard/word-to-pdf.png")}
                className="dashboard-card-icon"
              />
              <div>
                <br />
                <Title level={5} style={{ margin: 0 }}>
                  Word to PDF
                </Title>
                <Paragraph style={{ margin: 0 }}>
                  Make your DOC and DOCX files more accessible by converting
                  them to PDF.
                </Paragraph>
              </div>
            </div>
          </Card>
        </Col>
        <Col span={12}>
          <Card
            size="small"
            hoverable
            className="dashboard-card"
            onClick={() => {
              navigate("/dashboard/excel2pdf");
            }}
          >
            <div className="dashboard-card-content">
              <img
                src={require("../../assets/dashboard/excel-to-pdf.png")}
                className="dashboard-card-icon"
              />
              <div>
                <br />
                <Title level={5} style={{ margin: 0 }}>
                  Excel to PDF
                </Title>
                <Paragraph style={{ margin: 0 }}>
                  Make your XLS and XLSX files more accessible by converting
                  them to PDF.
                </Paragraph>
              </div>
            </div>
          </Card>
        </Col>
        <Col span={12}>
          <Card
            size="small"
            hoverable
            className="dashboard-card"
            onClick={() => {
              navigate("/dashboard/ppt2pdf");
            }}
          >
            <div className="dashboard-card-content">
              <img
                src={require("../../assets/dashboard/powerpoint-to-pdf.png")}
                className="dashboard-card-icon"
              />
              <div>
                <br />
                <Title level={5} style={{ margin: 0 }}>
                  PowerPoint to PDF
                </Title>
                <Paragraph style={{ margin: 0 }}>
                  Make your PPT and PPTX files more accessible by converting
                  them to PDF.
                </Paragraph>
              </div>
            </div>
          </Card>
        </Col>
        <Col span={12}>
          <Card
            size="small"
            hoverable
            className="dashboard-card"
            onClick={() => {
              navigate("/dashboard/image2pdf");
            }}
            style={{ height: "100%" }}
          >
            <div className="dashboard-card-content">
              <img
                src={require("../../assets/dashboard/image-to-pdf.png")}
                className="dashboard-card-icon"
              />
              <div>
                <br />
                <Title level={5} style={{ margin: 0 }}>
                  Image to PDF
                </Title>
                <Paragraph style={{ margin: 0 }}>
                  Make your JPG and PNG images more accessible by converting
                  them to PDF.
                </Paragraph>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DashboardHome;
